const REGEX_URL = new RegExp(
  '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?',
);

export const isValidUrl = (url: string): boolean => REGEX_URL.test(url);

const REGEX_EMAIL_BAYER = new RegExp(/^[A-Za-z0-9._%+-]+@bayer.com$/i);

export const isBayer = (email: string) => REGEX_EMAIL_BAYER.test(email);
